export default "__VITE_ASSET__BpdeU6nu__"